<script lang="ts">
  export let step: any;
  export let item: any;
</script>

{#if step === 'choose-video'}
  <div class="image-item flex w-full flex-col gap-2 p-2">
    <div class="skeleton-bg aspect-video h-full" />
    <div class="flex flex-col gap-1">
      <div class="skeleton-bg h-4" />
      <div class="skeleton-bg h-4" />
    </div>
  </div>
{:else if step === 'choose-template'}
  <div class="p-2 {!item ? 'h-full w-full' : 'image-item w-1/4'} relative flex flex-col gap-2 text-ellipsis">
    <div class="skeleton-bg h-full {!item ? 'w-full' : ''} relative rounded-xl">
      <img alt="" src={item?.src || ''} class="relative z-10 h-full w-full rounded-xl opacity-0" />
    </div>
  </div>
{:else if step === 'select-subtitles'}
  <div class="rounded-md border-primary bg-white shadow-md">
    <div class="sub-item flex flex-col rounded-t-md">
      <div class="flex flex-grow flex-wrap gap-2 p-4">
        {#each item?.words || [] as i}
          <div class="flex">
            <div class="skeleton-bg rounded border-1.6 border-solid border-slate-200 px-2 text-transparent">
              {i.word}
            </div>
          </div>
        {/each}
      </div>
      <div class="flex gap-2 rounded-b-md bg-slate-100 px-4 py-2">
        <div class="skeleton-bg h-6 !w-6 rounded border-1.6 border-solid border-slate-200" />
        <div class="skeleton-bg h-6 !w-6 rounded border-1.6 border-solid border-slate-200" />
      </div>
    </div>
  </div>
{/if}

<style lang="postcss">
  .skeleton-bg {
    @apply w-full;
    background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);
    background-size: 200% 100%;
    animation: shine 1s infinite;
  }

  @keyframes shine {
    100% {
      background-position-x: -200%;
    }
  }
</style>
